import { APICore } from "./apiCore";

const api = new APICore();

const getStatusProntuarios = (queryString?: string) => {
  return api.get(`/status-prontuario${queryString ? queryString : ""}`);
};

export { getStatusProntuarios };
